import { routenames } from '@/router/routenames';
import { RouteLocationRaw } from 'vue-router';

export function deviceDetailLocation(id: string): RouteLocationRaw {
  return { name: routenames.qaEquipment.details, params: { id } };
}
